import formatDate from './formatDate';
import formatTime from './formatTime';

const formatDateTime = (timestamp) => {
  return `${formatDate(timestamp)} ${formatTime(timestamp)}`;
};

export default formatDateTime;
